import getScreenResolution from './getScreenResolution';
import isBrowser from './isBrowser';

const getDeviceData = async () => {
  if (!isBrowser) {
    // Return empty data or defaults if not in a browser environment
    return {
      resolution: null,
    };
  }

  // If in a browser, gather and return the data
  return {
    resolution: await getScreenResolution(),
  };
};

export default getDeviceData;
